import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const OrderNumber = {
  id: 'orderNumber',
  displayName: <FormattedMessage {...messages.orderNumber} />,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'OrderNumber',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
